import api from './api';

export const logbookApi = {
  list: () => api.get('logbooks/'),
  get: (id) => api.get(`logbooks/${id}/`),
  create: (vehicleId) => api.post('logbooks/', { vehicle: vehicleId }),
  close: (id) => api.post(`logbooks/${id}/close/`),
  closeWithoutRefuel: (id) => api.post(`logbooks/${id}/close_without_refuel/`),
  saveAndSwitch: (id, vehicleId, km) =>
    api.post(`logbooks/${id}/save_and_switch/`, { vehicle_id: vehicleId, km }),
  delete: (id) => api.delete(`logbooks/${id}/`),
};

export const logEntryApi = {
  create: (data) => api.post('log-entries/', data),
  patch: (id, data) => api.patch(`log-entries/${id}/`, data),
};

export const fleetApi = {
  list: () => api.get('fleet/'),
};

export const stationsApi = {
  list: (category) => api.get(`available-stations/?category=${category}`),
};

export const userApi = {
  me: () => api.get('me/'),
};